import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Select, SelectTrigger, SelectContent, SelectItem } from "../Select";

function DropdownCompanies({ allCompanies, selectedCompany, setSelectedCompany, error, ...props }) {
  const classes = useStyles();

  return (
    <Select
    value={selectedCompany || null}
    onChange={setSelectedCompany}
    error={error}
    searchable={true}
    placeholder="Select a company"
    size="small"
    fullwidth
    {...props}
    >
    <SelectTrigger>{selectedCompany?.name}</SelectTrigger>
    <SelectContent>
        <SelectItem value={null} searchText="none">
        None
        </SelectItem>
        {allCompanies?.map((company) => (
        <SelectItem key={company.id} value={company} searchText={company.name}>
            {company.name}
        </SelectItem>
        ))}
    </SelectContent>
    </Select>
  );
}

export default DropdownCompanies

const useStyles = makeStyles({
});
